import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DestinationCenter } from '@app/models/destination-center';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class DestinationCenterService {
  constructor(private http: HttpClient) {}

  get(FollowId) {
    return this.http.get<DestinationCenter[]>(
      `${API}destination-center/${FollowId}`
    );
  }

  // getAllDestination(){
  //   const opts = 0
  //   return this.http.get<DestinationCenter[]>(
  //     `${API}destination-center/getAll/${opts}`,
  //   );
  // }

  getAll(){
    return this.http.get<DestinationCenter[]>(
      `${API}destination-center/`
    );
  };

  update(IdDestination,data) {
    const dataInfo = {
      name: data
    } 
    return this.http.put<DestinationCenter>(`${API}destination-center/${IdDestination}`,dataInfo);
  }

  create(data){
    return this.http.post<DestinationCenter>(`${API}destination-center/`,data)
  }

  delete(data){
    return this.http.put<DestinationCenter>(`${API}destination-center/delete/${data.BusinessId}`,data)    
  }
}
